import * as Svg from './gousto-icons';
import * as MaterialSvg from './material-design-icons';

export const iconRegistry = {
  '5_a_day': Svg.Svg5ADay,
  account_balance: MaterialSvg.SvgAccountBalance,
  add: Svg.SvgAdd,
  arrow_back: Svg.SvgArrowBack,
  arrow_down: Svg.SvgArrowDown,
  arrow_right: Svg.SvgArrowRight,
  arrow_up: Svg.SvgArrowUp,
  assignment: MaterialSvg.SvgAssignment,
  book: MaterialSvg.SvgBook,
  bullet_point: Svg.SvgBulletPoint,
  calendar: Svg.SvgCalendar,
  calories: Svg.SvgCalories,
  card_giftcard: MaterialSvg.SvgCardGiftcard,
  chat: Svg.SvgChat,
  checkbox_default: Svg.SvgCheckboxDefault,
  checkbox_indeterminate: Svg.SvgCheckboxIndeterminate,
  checkbox_selected: Svg.SvgCheckboxSelected,
  chevron_down: Svg.SvgChevronDown,
  chevron_large_down: Svg.SvgChevronLargeDown,
  chevron_large_left: Svg.SvgChevronLargeLeft,
  chevron_large_right: Svg.SvgChevronLargeRight,
  chevron_large_up: Svg.SvgChevronLargeUp,
  chevron_left: Svg.SvgChevronLeft,
  chevron_right: Svg.SvgChevronRight,
  chevron_up: Svg.SvgChevronUp,
  clear: Svg.SvgClear,
  close: Svg.SvgClose,
  contact_page: MaterialSvg.SvgContactPage,
  cookbook: Svg.SvgCookbook,
  cooking_time: Svg.SvgCookingTime,
  coronavirus: MaterialSvg.SvgCoronavirus,
  cookmode: Svg.SvgCookmode,
  cool: Svg.SvgCool,
  credit_card: MaterialSvg.SvgCreditCard,
  credit_score: MaterialSvg.SvgCreditScore,
  currency_pound: MaterialSvg.SvgCurrencyPound,
  dairy_free: Svg.SvgDairyFree,
  delete: Svg.SvgDelete,
  delivery: Svg.SvgDelivery,
  dietary_preference: Svg.SvgDietaryPreference,
  edit: Svg.SvgEdit,
  edit_note: MaterialSvg.SvgEditNote,
  email: Svg.SvgEmail,
  equipment: Svg.SvgEquipment,
  error: Svg.SvgError,
  event_available: MaterialSvg.SvgEventAvailable,
  flag: MaterialSvg.SvgFlag,
  frequency: Svg.SvgFrequency,
  fullscreen_exit: Svg.SvgFullscreenExit,
  fullscreen_open: Svg.SvgFullscreenOpen,
  gluten_free: Svg.SvgGlutenFree,
  gousto_g: Svg.SvgGoustoG,
  grain: MaterialSvg.SvgGrain,
  heart_default: Svg.SvgHeartDefault,
  heart_selected: Svg.SvgHeartSelected,
  help: Svg.SvgHelp,
  hide: Svg.SvgHide,
  home: Svg.SvgHome,
  info: Svg.SvgInfo,
  inventory: MaterialSvg.SvgInventory,
  local_offer_rounded: MaterialSvg.SvgLocalOfferRounded,
  local_shipping: MaterialSvg.SvgLocalShipping,
  lunch_dining: MaterialSvg.SvgLunchDining,
  map: MaterialSvg.SvgMap,
  meals_per_box: Svg.SvgMealsPerBox,
  menu: Svg.SvgMenu,
  menu_book: MaterialSvg.SvgMenuBook,
  more_horizontal: Svg.SvgMoreHorizontal,
  more_vertical: Svg.SvgMoreVertical,
  nut_free: Svg.SvgNutFree,
  offer_percentage: Svg.SvgOfferPercentage,
  offer_pound: Svg.SvgOfferPound,
  offer: Svg.SvgOffer,
  park: MaterialSvg.SvgPark,
  payment: Svg.SvgPayment,
  payments: MaterialSvg.SvgPayments,
  people_alt_rounded: MaterialSvg.SvgPeopleAltRounded,
  phone: Svg.SvgPhone,
  play_pause: Svg.SvgPlayPause,
  portion_size: Svg.SvgPortionSize,
  profile: Svg.SvgProfile,
  public: MaterialSvg.SvgPublic,
  radio_default: Svg.SvgRadioDefault,
  radio_selected: Svg.SvgRadioSelected,
  rate_empty: Svg.SvgRateEmpty,
  rate_full: Svg.SvgRateFull,
  rate_half: Svg.SvgRateHalf,
  recycling: MaterialSvg.SvgRecycling,
  redo: MaterialSvg.SvgRedo,
  refer_a_friend: Svg.SvgReferAFriend,
  remove: Svg.SvgRemove,
  report_gmailerrorred: MaterialSvg.SvgReportGmailerrorred,
  report_problem: MaterialSvg.SvgReportProblem,
  restaurant: MaterialSvg.SvgRestaurant,
  savings: MaterialSvg.SvgSavings,
  schedule: Svg.SvgSchedule,
  search: Svg.SvgSearch,
  secure: Svg.SvgSecure,
  serving_size: Svg.SvgServingSize,
  set_meal: MaterialSvg.SvgSetMeal,
  share: Svg.SvgShare,
  shopping_bag: MaterialSvg.SvgShoppingBag,
  show: Svg.SvgShow,
  skip: Svg.SvgSkip,
  smartphone: MaterialSvg.SvgSmartphone,
  social_facebook: Svg.SvgSocialFacebook,
  social_instagram: Svg.SvgSocialInstagram,
  social_twitter: Svg.SvgSocialTwitter,
  social_youtube: Svg.SvgSocialYoutube,
  storefront: MaterialSvg.SvgStorefront,
  stock_down: Svg.SvgStockDown,
  stock_left: Svg.SvgStockLeft,
  stock_right: Svg.SvgStockRight,
  stock_up: Svg.SvgStockUp,
  success: Svg.SvgSuccess,
  support: MaterialSvg.SvgSupport,
  task_alt: MaterialSvg.SvgTaskAlt,
  tick: Svg.SvgTick,
  time: Svg.SvgTime,
  turned_in_rounded: MaterialSvg.SvgTurnedInRounded,
  use_by: Svg.SvgUseBy,
  vegan: Svg.SvgVegan,
  vegetarian: Svg.SvgVegetarian,
  view_in_ar: MaterialSvg.SvgViewInAr,
  warning: Svg.SvgWarning,
  world_cuisine: Svg.SvgWorldCuisine,
};
